import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'components/elements'
import SearchFilterPopUp from '../searchTippyPopup/searchTippyPopUp'
import { addToUrlPush, removeFromUrlPush } from '../filterUtil.js'
import { bikeBrands } from 'constants/index'
import { brandDefault, BRAND_FILTER_SHORT_NAME } from './searchBrandConfig'
import { PAGE_FILTER_SHORT_NAME } from '../pagination/paginationFilterConfig'
import ChipGroup from '../filterInputs/chipGroup.js'
import './../../../theme/assets/styles/updated.sass'

let classNames = require('classnames')

class StyleFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      buttonLabel: this.buildButtonLabel(this.props?.currentBrands?.length),
      currentBrands: this.props.currentBrands,
      active: this.isValueDefault(this.props?.currentBrands?.length)
        ? false
        : true,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentBrands !== this.props.currentBrands) {
      this.setState({
        currentBrands: this.props.currentBrands,
        buttonLabel: this.buildButtonLabel(this.props?.currentBrands?.length),
        active: this.isValueDefault(this.props?.currentBrands?.length)
          ? false
          : true,
      })
    }
  }

  handleApply = () => {
    this.closeFilter()
    let locationSearchUrl = this.props.location.search
    if (this.props.location.search?.includes('&page=')) {
      let tempLocationSearch = removeFromUrlPush(
        [PAGE_FILTER_SHORT_NAME],
        locationSearchUrl
      )
      locationSearchUrl = tempLocationSearch?.string
    }
    if (this.isValueDefault(this.state?.currentBrands?.length)) {
      this.setState({ active: false })
      let newQueryString = removeFromUrlPush(
        [BRAND_FILTER_SHORT_NAME],
        locationSearchUrl
      )
      this.props.history.push('?' + newQueryString.string)
    } else {
      this.setState({ active: true })

      let valuesToAdd = [
        { key: BRAND_FILTER_SHORT_NAME, value: this.state.currentBrands },
      ]
      let newQueryString = addToUrlPush(valuesToAdd, locationSearchUrl)
      this.props.history.push('?' + newQueryString.string)
    }
    this.setState({
      buttonLabel: this.buildButtonLabel(this.state?.currentBrands?.length),
    })
    this.props.onApply(this.state.currentBrands)
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.props.onOpen()
  }

  closeFilter = () => {
    this.setState({ open: false })
    this.props.onClose()
  }

  buildButtonLabel = (count, long) => {
    let newButtonLabel = this.props.defaultLabel

    if (this.isValueDefault(count)) {
      newButtonLabel = 'Brand'
    } else {
      newButtonLabel = 'Brands · ' + count
    }
    return newButtonLabel
  }

  isValueDefault = (count) => {
    if (!count) {
      return true
    }
    if (count === 0) {
      return true
    } else {
      return false
    }
  }

  render() {
    const { open, buttonLabel, active, currentBrands } = this.state

    let filterBtnClass = classNames(
      'filterBtnClass filters-bar-buttons',
      this.props.className,
      {
        'is-primary': active || open,
      }
    )

    return (
      <SearchFilterPopUp
        triggerClassName={filterBtnClass}
        triggerText={
          <>
            <span>
              {buttonLabel}
            </span>
            <span className="icon mt-1">
                &nbsp;<i className="fa fa-angle-down"></i>
            </span>
          </>
        }
        on="click"
        open={open}
        onClose={() => this.closeFilter()}
        onOpen={() => this.handleOpen()}
      >
        <div className="search-filter-inner-wrapper brand-filters-wrapper">
          <h2 className="is-size-4 has-text-weight-extra-bold">Brand</h2>
          <div className="mt-5">
            <ChipGroup
              chipData={bikeBrands}
              labelKey={'value'}
              valueKey={'value'}
              onChange={(values) => this.setState({ currentBrands: values })}
              selectedChips={currentBrands}
            />
          </div>
          <div className="has-text-right search-filter-apply-btn mt-4">
            <Button onClick={this.handleApply}>Apply</Button>
          </div>
        </div>
      </SearchFilterPopUp>
    )
  }
}

export default withRouter(StyleFilter)

StyleFilter.defaultProps = {
  currentBrands: brandDefault,
  defaultLabel: 'Brand',
  onApply: function () { },
  onOpen: function () { },
  onClose: function () { },
  onClear: function () { },
  pushToUrl: true,
  grabFromUrl: true, //if this is true then it will override the defaultBrands prop
}
